.stickyHeaderSprintsContainer {
	position: relative;
	height: 100%;
	background-color: var(--ds-background-neutral, var(--adg3-color-N40));
}
